import React, { useState } from 'react';

// BOOTSTRAP COMPONENTS
import { Collapse } from 'react-bootstrap';

// CORE COMPONENTS

import Button from 'core/tools/Button';

// STYLES
import styles from './dealTasksCollapse.module.scss';

// MAIN COMPONENT
const DealTasksCollapse = ({ children, title, tools }) => {

  //STATE
  const [ active, setActive ] = useState(true);

  // RENDER
  return (
    <div className={styles.outer}>
      <Button
        className={styles.toggle}
        variant="custom"
        label={<><span className={styles.title}>{title}</span>{tools}</>}
        icon={{
          use: active ? 'chevron-up' : 'chevron-down',
          order: 1
        }}
        onClick={() => setActive(!active)}
      />
      <Collapse in={active}>
        <div>
          <div className={styles.inner}>
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

// EXPORT
export default DealTasksCollapse;
